import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { FAQ } from '../types';

export default function FAQAccordion({ faqs }: { faqs: FAQ[] }) {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <div className="space-y-3">
      {faqs.map((faq) => (
        <div
          key={faq.id}
          className={`rounded-xl border transition-all duration-300 ${
            openId === faq.id
              ? 'bg-[#0f2240]/60 border-[#c9a84c]/30'
              : 'bg-[#0a1628]/40 border-[#c9a84c]/10 hover:border-[#c9a84c]/20'
          }`}
        >
          <button
            onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
            className="w-full flex items-center gap-4 p-6 text-left"
          >
            <HelpCircle className="w-5 h-5 text-[#c9a84c] shrink-0" />
            <span className="flex-1 text-[#e8e4dc] font-medium text-sm">{faq.question}</span>
            <ChevronDown
              className={`w-5 h-5 text-[#c9a84c]/60 shrink-0 transition-transform duration-300 ${
                openId === faq.id ? 'rotate-180' : ''
              }`}
            />
          </button>
          <AnimatePresence>
            {openId === faq.id && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="px-6 pb-6 pl-15">
                  <p className="text-sm text-[#e8e4dc]/60 leading-relaxed">{faq.answer}</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
